export default __webpack_public_path__ + "static/media/agregar-dinero-up.40dabdca.png";